import angular from 'angular';
import navBreadCrumb from './navBreadCrumb';
import './style.scss';

export default angular
  .module('components.navBreadCrumb', [])
  .component('navBreadCrumb', navBreadCrumb).name;
